import { createSlice } from '@reduxjs/toolkit';
import { addTag, fetchTags, removeTag, editTag } from '../actions/tags-actions';
import { Status } from '../../helpers/consts/status';

const initialState = {
  status: Status.IDLE,
  tags: [],
  count: 0,
};

const tagsSlice = createSlice({
  name: 'tags',
  initialState: initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(fetchTags.pending, (state, action) => {
        state.status = Status.LOADING;
      })
      .addCase(fetchTags.fulfilled, (state, action) => {
        const tags = action.payload;
        state.tags = tags;
        state.isLoading = false;
        state.status = Status.COMPLETED;
      })
      .addCase(fetchTags.rejected, (state, action) => {
        
      })
      .addCase(addTag.fulfilled, (state, action) => {
        const newTag = action.payload;
        state.tags.push(newTag);
      })
      .addCase(editTag.fulfilled, (state, action) => {
        const data = action.payload;
        const index = state.tags.findIndex((tag) => tag.id === data.id);
        if (~index) {
          state.tags[index] = data;
        }
      })
      .addCase(removeTag.fulfilled, (state, action) => {
        const tagId = action.payload;
        console.log(action.payload)

        state.tags = state.tags.filter((tag) => tag.id !== tagId);
      });
  },
});

export const tagsActions = tagsSlice.actions;

export default tagsSlice;
